
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Header from './header';
import Nav from './nav';

const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 82;

const SIDEBAR_EXPANDED = 240;
const SIDEBAR_COLLAPSED = 80;

const StyledRoot = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  height: '100dvh',
  minHeight: 0,
  overflow: 'hidden',
}));

const RightPanel = styled('div')(() => ({
  display: 'flex',
  flex: '1 1 0%',
  flexDirection: 'column',
  minWidth: 0,
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
}));

const Main = styled('main', {
  shouldForwardProp: (prop) => prop !== 'openmenu',
})(({ theme, openmenu }) => ({
  flex: '1 1 0%',
  minWidth: 0,
  minHeight: 0,
  width: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(3),

  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(3),
  },

  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout({ role }) {
  const [openNav, setOpenNav] = useState(false);
  const [openmenu, setOpenmenu] = useState(false);

  const handleOpenNav = () => {
    setOpenNav(true);
  };

  const handleCloseNav = () => {
    setOpenNav(false);
  };

  return (
    <StyledRoot>
      <Nav
        openNav={openNav}
        onCloseNav={handleCloseNav}
        role={role}
        openmenu={openmenu}
        setOpenmenu={setOpenmenu}
      />

      <RightPanel>
        <Header
          onOpenNav={handleOpenNav}
          openmenu={openmenu}
          setOpenmenu={setOpenmenu}
        />

        <Main openmenu={openmenu}>
          <Outlet />
        </Main>
      </RightPanel>
    </StyledRoot>
  );
}

DashboardLayout.propTypes = {
  role: PropTypes.string,
};
